import React, { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { OptionProps } from '@match/react-component-library';
import { Box, constants, Select } from '@match/react-component-library';

const { SPACE } = constants;

interface CategoryDropdownProps {
  categoryChoices: string[];
  onCategorySelect: (selection?: OptionProps<{}> | undefined) => void;
}

export const CategoryDropdown: FunctionComponent<CategoryDropdownProps> = ({
  categoryChoices,
  onCategorySelect,
}) => {
  const intl = useIntl();

  return (
    <Box marginBottom={SPACE.XLARGE}>
      <Box marginBottom={SPACE.SMALL}>
        <FormattedMessage {...messages.category} />
      </Box>
      <Select
        buttonAriaLabelClear={intl.formatMessage(messages.selectAriaClear)}
        buttonAriaLabelDownArrow={intl.formatMessage(messages.selectAriaDown)}
        buttonAriaLabelUpArrow={intl.formatMessage(messages.selectAriaUp)}
        id="categorySelect"
        isCombobox
        name="categorySelect"
        onSelect={onCategorySelect}
        placeholder={intl.formatMessage(messages.selectCategory)}
      >
        {categoryChoices.map((categoryChoice: string) => {
          return (
            <Select.Option key={categoryChoice} value={categoryChoice}>
              {categoryChoice}
            </Select.Option>
          );
        })}
      </Select>
    </Box>
  );
};

const messages = defineMessages({
  category: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/CategoryDropdown/CategoryDropdown:category',
    description: 'category section header',
    defaultMessage: 'Category',
  },
  selectAriaUp: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/CategoryDropdown/CategoryDropdown:selectAriaUp',
    description: 'up text',
    defaultMessage: 'up',
  },
  selectAriaDown: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/CategoryDropdown/CategoryDropdown:selectAriaDown',
    description: 'down text',
    defaultMessage: 'down',
  },
  selectAriaClear: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/CategoryDropdown/CategoryDropdown:selectAriaClear',
    description: 'clear text',
    defaultMessage: 'clear',
  },
  selectCategory: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/CategoryDropdown/CategoryDropdown:selectCategory',
    description: 'select category dropdown placeholder',
    defaultMessage: 'Select Category',
  },
});
